<div class="grid" style="margin-top: 4px;">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <h5 class="m-0">{{ 'menu.traceability' | transloco }}</h5>
            <div>
              <button
                [label]="'common.requeuemessages' | transloco"
                (click)="requeueSelectedDocuments()"
                pButton
                class="p-button-secondary mr-2"
                icon="pi pi-cloud-upload"
              ></button>
              <button
                [label]="'common.filters' | transloco"
                (click)="showFiltersMenu()"
                pButton
                class="p-button-secondary"
                [ngClass]="{ 'filtersFilled': !filtersForm.invalid }"
                [icon]="filtersForm.invalid ? 'pi pi-sliders-h' : 'pi pi-filter'"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selectedDocuments"
          [value]="data.hits"
          [totalRecords]="totalDocuments"
          [responsive]="true"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          dataKey="_source.traceId"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width"></th>
              <th class="selection-column-width"></th>
              <th pSortableColumn="name">
                {{ 'attribute.process' | transloco }}
              </th>
              <th pSortableColumn="description">
                {{ 'attribute.timestamp' | transloco }}
              </th>
              <th pSortableColumn="subscriptionType">
                {{ 'attribute.type' | transloco }}
              </th>
              <th pSortableColumn="protocol">
                {{ 'attribute.protocol' | transloco }}
              </th>
              <th pSortableColumn="tenant">
                {{ 'attribute.tenant' | transloco }}
              </th>
              <th pSortableColumn="organization">
                {{ 'attribute.organization' | transloco }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-document let-expanded="expanded">
            <tr *ngIf="!loadingDocuments" class="fadein">
              <td>
                <button
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  [pRowToggler]="document"
                  pButton
                  pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  type="button"
                ></button>
              </td>
              <td>
                <p-tableCheckbox [value]="document"></p-tableCheckbox>
              </td>
              <td>
                {{ document._source.process }}
              </td>
              <td>
                {{ document._source.timestamp | customDate }}
              </td>
              <td>
                <p-tag [value]="getType(document._source)"
                       [severity]="document._source.level === 'ERROR' ? 'danger' : 'info'">
                </p-tag>
              </td>
              <td style="overflow:hidden; text-overflow:ellipsis;">
                {{ document._source.msgTracingProtocol }}
                <i class="font-light">({{ document._source.msgTracingPoint }})</i>
              </td>
              <td>{{ document._source.tenant }}</td>
              <td>{{ document._source.organization }}</td>
            </tr>
            <tr *ngIf="loadingDocuments" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-document>
            <tr>
              <td colspan="8">
                <div class="grid">
                  <div [ngClass]="{ 'col-6' : document._source.stackTrace , 'col-12' : !document._source.stackTrace}">
                    <b>{{ 'attribute.message' | transloco }}:</b>
                  </div>
                  <div class="col-6" *ngIf="document._source.stackTrace">
                    <b>{{ 'attribute.stacktrace' | transloco }}:</b>
                  </div>
                  <div [ngClass]="{ 'col-6' : document._source.stackTrace , 'col-12' : !document._source.stackTrace}">
                    <ngx-json-viewer [expanded]="false" [json]="document._source.message"></ngx-json-viewer>
                  </div>
                  <div class="col-6" *ngIf="document._source.stackTrace">
                    <p style="overflow:hidden;" [innerHTML]="document._source.stackTrace.substr(0, 200)">
                      <p-button (click)="showStackTrace(document._source.stackTrace)"
                                icon="pi pi-ellipsis-h"></p-button>
                    </p>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalDocuments == 0">
              {{ 'pagination.empty' | transloco }}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalDocuments > 0">
              {{ 'pagination.showing' | transloco }} {{ first + 1 }}
              {{ 'pagination.to' | transloco }} {{ (first + rows) >= totalDocuments ? totalDocuments : (first + rows) }}
              {{ 'pagination.of' | transloco }} {{ totalDocuments }}
              {{ (totalDocuments > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="displayStackTrace"
  [header]="'attribute.stacktrace' | transloco"
  [breakpoints]="{'960px': '80vw', '640px': '100vw'}"
  [style]="{width: '60vw'}"
  [baseZIndex]="10000"
>
  <p [innerHTML]="stackTrace"></p>
  <ng-template pTemplate="footer">
    <p-button
      (click)="displayStackTrace=false"
      styleClass="p-button-text"
      icon="pi pi-check"
      label="Ok"
    ></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="displayDataflowDiagram"
  [header]="'attribute.stacktrace' | transloco"
  [breakpoints]="{'960px': '80vw', '640px': '100vw'}"
  [style]="{width: '50vw'}"
  [baseZIndex]="10000"
>
  <div class="card" style="height: 770px;">
    <app-dataflow-graph (processSelected)="processSelected($event)"></app-dataflow-graph>
  </div>
</p-dialog>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}"
           (onHide)="displayDataflowDiagram = false">
  <h2 style="margin-left: 10px">{{ 'common.filters' | transloco }}</h2>
  <form [formGroup]="filtersForm" (ngSubmit)="applyFilters()">
    <div class="col-12 form-field">
      <label for="exceptionSearchTerm">{{ 'attribute.exceptionSearchTerm' | transloco }}</label>
    </div>
    <div class="col-12 form-field">
      <input
        formControlName="exceptionSearchTerm"
        pInputText
        class="w-full"
        id="exceptionSearchTerm"
        type="text"
      >
    </div>

    <div class="col-12 form-field flex align-items-center justify-content-between">
      <label for="process">{{ 'attribute.process' | transloco }}</label>
      <button
        id="processes-map-button"
        pButton
        pRipple
        class="p-button-rounded"
        icon="pi pi-sitemap"
        type="button"
        (click)="showDataFlowDiagram()"
      ></button>
    </div>
    <div class="col-12">
      <p-dropdown
        formControlName="process"
        [placeholder]="'select.generic' | transloco"
        [options]="processes"
        [filter]="true"
        styleClass="w-full"
        id="process"
        optionLabel="id"
        optionValue="id"
        filterBy="id"
        appendTo="body"
        [showClear]="true"
      ></p-dropdown>
    </div>

    <div class="col-12 form-field">
      <label for="minutesPicker">{{ 'attribute.endDate' | transloco }}</label>
    </div>
    <div class="col-12">
      <p-dropdown
        formControlName="timeAgo"
        [placeholder]="'select.generic' | transloco"
        [options]="timeOptions"
        styleClass="w-full"
        id="minutesPicker"
        optionValue="timeInMinutes"
        appendTo="body"
        [showClear]="true"
      >
        <ng-template pTemplate="selectedItem" let-item>
          {{ 'date.timeAgo' | transloco:{ time: item.time, unit: ('date.' + item.unit | transloco) } }}
        </ng-template>
        <ng-template pTemplate="item" let-item>
          {{ 'date.timeAgo' | transloco:{ time: item.time, unit: ('date.' + item.unit | transloco) } }}
        </ng-template>
      </p-dropdown>
    </div>

    <div class="col-12 form-field">
      <label for="tenant">{{ 'model.tenant' | transloco }}</label>
    </div>
    <div class="col-12">
      <p-dropdown
        formControlName="tenant"
        [placeholder]="'select.generic' | transloco"
        [options]="tenants"
        [filter]="true"
        styleClass="w-full"
        id="tenant"
        optionLabel="name"
        optionValue="name"
        filterBy="name"
        appendTo="body"
        [showClear]="true"
      ></p-dropdown>
    </div>

    <div class="col-12 form-field">
      <label for="organization">{{ 'model.organization' | transloco }}</label>
    </div>
    <div class="col-12">
      <p-dropdown
        formControlName="organization"
        [placeholder]="'select.generic' | transloco"
        [options]="organizations"
        [filter]="true"
        [disabled]="!filtersForm.get('tenant').value"
        styleClass="w-full"
        id="organization"
        optionLabel="name"
        optionValue="name"
        filterBy="name"
        appendTo="body"
        [showClear]="true"
      ></p-dropdown>
    </div>

    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="filtersForm.invalid"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="sumit"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>

  </form>
</p-sidebar>
